export enum Path {
  BASE = "*",
  DEFAULT = "/",
  CHOOSE_CRYPTO = "/crypto",
  STANDARD_METHODS = "/standard",
  CONFIRM_PAYMENT = "/confirmpayment",
  PAYMENT_STATUS = "/status",
  QR_PAYMENT = "/qrpayment",
}
